import {
  EVIDENCE_READ_ONLY_FIELDS,
  EvidenceGroup,
} from '@trustero/trustero-api-web/lib/attachment/attachment_pb'
import {
  Control,
  CONTROL_READ_ONLY_FIELDS,
} from '@trustero/trustero-api-web/lib/model/control_pb'
import {
  POLICY_READ_ONLY_FIELDS,
  PolicyRecord,
} from '@trustero/trustero-api-web/lib/model/policy_pb'

type ControlIsFieldReadOnlyProps = {
  object: Control.AsObject
  field: CONTROL_READ_ONLY_FIELDS
}

type PolicyIsFieldReadOnlyProps = {
  object: PolicyRecord.AsObject
  field: POLICY_READ_ONLY_FIELDS
}

type EvidenceIsFieldReadOnlyProps = {
  object: EvidenceGroup.AsObject
  field: EVIDENCE_READ_ONLY_FIELDS
}

type IsFieldReadOnlyProps =
  | ControlIsFieldReadOnlyProps
  | PolicyIsFieldReadOnlyProps
  | EvidenceIsFieldReadOnlyProps

export const getIsFieldReadOnly = ({
  object,
  field,
}: IsFieldReadOnlyProps): boolean | undefined => {
  // Use type assertion to help TypeScript understand the type
  const fieldsList = object.readOnlyFields?.fieldsList
  let isReadOnly
  let isWarningDismissed
  if (fieldsList) {
    for (const f of fieldsList) {
      if (f.field === field) {
        isReadOnly = f.details?.isReadOnly?.value
        isWarningDismissed = f.details?.isWarningDismissed?.value
      }
    }
  }
  return isReadOnly && !isWarningDismissed
}
